import { LIST_BILLINGS } from '@/data/actions/modules/financial';

export default [
  {
    path: '/financial/billing-dashboard',
    component: () => import(/* webpackChunkName: "billing-dashboard" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_BILLINGS,
    },
  },
];
